import { render, staticRenderFns } from "./PopoverNumbering.vue?vue&type=template&id=aa88b0fa"
import script from "./PopoverNumbering.vue?vue&type=script&lang=js"
export * from "./PopoverNumbering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports